import React, { useEffect, useMemo } from 'react';
import RestShow from 'containers/rest/Show';
import i18next from 'i18next';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { getSummaryDetailContact } from 'redux/contacts/actions';
import { getCentreId } from 'redux/auth/selectors';

import { getParentProfileData } from 'redux/contacts/selectors';
import ContactDetailTabs from './ContactDetailTabs';

const ContactsShow = () => {
  const { id, model } = useParams();

  const centreId = useSelector(getCentreId);
  const parentProfileData = useSelector(getParentProfileData);

  const dispatch = useDispatch();

  const customBreadcrumb = useMemo(
    () => [
      {
        title: i18next.t('contacts.header'),
        path: `/contacts/${model || 'board'}`,
      },
      {
        title: `${parentProfileData.firstName} ${parentProfileData.lastName}`,
      },
    ],
    [parentProfileData.firstName, model, parentProfileData.lastName],
  );

  useEffect(() => {
    id && dispatch(getSummaryDetailContact(id));
  }, [centreId, dispatch, id]);

  return (
    <RestShow
      isResetStyle
      hasEdit={false}
      resource="contacts"
      customBreadcrumb={customBreadcrumb}
      header="contacts.titleDetail"
      defaultOptions={{ suffixUrl: '/details' }}
    >
      <ContactDetailTabs />
    </RestShow>
  );
};

export default ContactsShow;
